<p-divider [layout]="layout()" [align]="align()">{{ label() }}</p-divider>
